import React from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { FormikInput, SimpleSelect } from '../../../components';

export const QuestionDescriptionFields = ({ valuePath, descriptionPlaceholder }) => {
  const { errors, touched } = useFormikContext();
  return (
    <>
      <Row>
        <Col md={10}>
          <Field name={`${valuePath}[label]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Pregunta"
                maxLength={100}
                tooltipText="Máximo 100 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Field name={`${valuePath}[description]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Descripción opcional"
                maxLength={300}
                placeholder={descriptionPlaceholder}
                tooltipText="Máximo 300 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
    </>
  );
};

export const ScaleSelect = ({ label, options, value, onChange }) => {
  const id = `scale-select-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <div className="mb-3">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
      <label htmlFor={id} className="eval-scale-label">
        {label}
      </label>
      <SimpleSelect
        options={options}
        value={options.find(opt => String(opt.value) === String(value))}
        onChange={selected => onChange(selected ? selected.value : '')}
      />
    </div>
  );
};
